import { observer } from 'mobx-react';
import React from 'react';
import { RichTextEditor, RichTextEditorToolbar } from 'lib/cortiUI';
export const TextElementWidget = observer(function TextElementWidget({ model, }) {
    return (React.createElement("div", null,
        React.createElement(RichTextEditor, { "data-cy": "text-element-widget", style: { maxHeight: 160 }, value: model.content, onChange: (value) => model.setContent(value) },
            React.createElement(RichTextEditorToolbar, null))));
});
